import { styled } from "styled-components";
import { CardStyle } from "../../page/Homev2/styled";

export const EcosystemStyle = styled.div`
  position: relative;
  margin-bottom: 150px;
  z-index: 5;
  @media screen and (max-width: 1023px) {
    margin-bottom: 100px;
  }
  @media screen and (max-width: 767px) {
    margin-bottom: 100px;
  }
  .container {
    max-width: 1160px;
    margin: 0 auto;
  }
  .title {
    padding: 120px 0 60px;
    padding-bottom: 36px;
    text-align: center;
    .eco-system {
      button {
        margin-bottom: 18px;
      }
    }
    .checkout-prod {
      p {
        max-width: 324px;
        color: #a0aee5;
        font-size: 12px;
        letter-spacing: 0.268px;
        margin-bottom: 10px;
      }
      .btn-and-icon-light {
        button {
          width: 176.72px;
          height: 41.018px;
        }
        display: flex;
        gap: 10px;
        align-items: center;
      }
    }
    @media screen and (max-width: 1023px) {
      padding: 100px 20px 60px;
      .sm {
        display: none;
      }
    }
    @media screen and (max-width: 769px) {
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .eco-system,
      .checkout-prod {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        p {
          text-align: center;
        }
        .btn-and-icon-light {
          margin-top: 20px;
          .image {
            display: none;
          }
        }
      }
    }
    @media screen and (max-width: 481px) {
      display: flex;
      flex-direction: column;
      padding: 100px 20px 60px;
      gap: 20px;
    }
  }
  .content {
    position: relative;
    z-index: 3;
    .row {
      ${CardStyle} {
        padding: 24px !important;
        &:not(:last-child) {
          margin-bottom: 20px;
        }
        &:nth-child(2n+2) {
          .inner {
            .header {
              order: 2;
            }
          }
        }
      }
      .card-style {
        padding: 5px;
        transition: all.3s;
        &:hover {
          transition: all.3s;
        }
        .header {
          padding: 22px 22px 0;
          margin-bottom: 20px;
          max-width: 515px;
          width: 100%;
          h3 {
            color: #ECF0FF;
            font-family: "Changa One";
            font-size: 20px;
            margin-bottom: 10px;
          }
          p {
            color: #898989;
            font-family: Inter;
            font-size: 15px;
            margin-bottom: 30px;
          }
        }
        .image {
          max-width: 520px;
          width: 100%;
          border-radius: 16px;
          img {
            width: 100%;
            border-radius: 16px;
          }
        }
        .inner {
          display: flex;
          justify-content: space-between;
          align-items: center;
          a {
            width: 178px;
            height: 45px;
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }
      }
      @media screen and (min-width: 768px) and (max-width: 1023px) {
        width: max-content;
      }
      @media screen and (max-width: 1023px) {
        flex-direction: column;
        align-items: center;
        padding: 0 20px;
        gap: 16px;
        margin: 0 auto;
        &:nth-child(2) {
          flex-direction: column;
          align-items: center;
          padding: 0 20px;
        }
        .card-style {
          &:nth-child(2n+1) {
            .inner {
              .image {
                order: 1;
              }
            }
            .header {
              order: 2;
            }
          }
          .header {
            padding: 0;
            margin-bottom: 0;
          }
          .inner {
            flex-direction: column;
            .image {
              margin-bottom: 15px;
            }
          }
        }
      }
    }
  }
`;

export const EcosystemBackground = styled.div`
  position: absolute;
  top: -110px;
  width: 100%;
  .img-round {
    width: 100%;
    position: relative;
    z-index: 3;
    &:after {
      z-index: 4;
      position: absolute;
      content: "";
      background: linear-gradient(
        90deg,
        #74bfff 11.01%,
        #a7d6f1 25.65%,
        #fac4b8 37.61%,
        #ffaf96 53.68%,
        #ff9bab 69.04%,
        #f09df0 81.09%,
        #c78fff 94.12%
      );
      opacity: 0.3;
      filter: blur(227px);
      width: 100%;
      height: 350px;
      position: absolute;
      bottom: -520px;
      left: 50%;
      transform: translate(-50%, -50%);
    }
    img {
      width: 100%;
    }
  }
  .img-purple {
    width: 100%;
    position: absolute;
    z-index: 2;
    bottom: 5px;
    pointer-events: none;
    img {
      width: 100%;
    }
  }
  @media screen and (min-width: 1024px) {
    top: -10vw;
  }
  @media screen and (min-width: 768px) and (max-width: 1023px) {
    top: -60px;
  }
  @media screen and (max-width: 767px) {
    top: -20vw;
  }
`;
export const EcosystemStarRight = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  @media screen and (max-width: 767px) {
    top: 0;
  }
`;
